/*
MIT LICENSE
Copyright (c) 2020-present Alibaba Cloud Design
Copied from 'antd/components/popover/index.tsx'.
Copyright (c) 2015-present Ant UED, https://xtech.antfin.com/

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE. */
import React from 'react';
import classNames from 'classnames';
import { ConfigContext } from '../config-provider';
import AnimationContext from '../config-provider/AnimationContext';
import { getRenderPropValue } from 'antd/lib/_util/getRenderPropValue';
import { getTransitionName } from 'antd/lib/_util/motion';
import useMergedState from 'rc-util/lib/hooks/useMergedState';
import { Tooltip } from '../tooltip';
import { Icon } from '../icon';
import { Button } from '../button';
const Popover = React.forwardRef((props, ref) => {
    const { prefixCls: customizePrefixCls, title, closeable, type, footer, content, okText, cancelText, footerAlign, overlayClassName, ...otherProps } = props;
    const [visible, setVisible] = useMergedState(false, {
        value: props.visible,
        defaultValue: props.defaultVisible
    });
    const { getPrefixCls } = React.useContext(ConfigContext);
    const animation = React.useContext(AnimationContext);
    const settingVisible = (value, e) => {
        setVisible(value);
        // @ts-ignore
        props.onVisibleChange?.(value, e);
    };
    const onVisibleChange = (value) => {
        const { disabled } = props;
        if (disabled) {
            return;
        }
        settingVisible(value);
    };
    const closeFunction = (e) => {
        settingVisible(false, e);
    };
    const onConfirm = (e) => {
        settingVisible(false, e);
        props.onConfirm?.call(this, e);
    };
    const onCancel = (e) => {
        settingVisible(false, e);
        props.onCancel?.call(this, e);
    };
    const renderFooter = () => {
        if (footer === false) {
            return null;
        }
        const footerContent = footer === true ? (React.createElement(React.Fragment, null,
            React.createElement(Button, { size: 'xs', type: 'primary', onClick: onConfirm }, okText),
            React.createElement(Button, { size: 'xs', onClick: onCancel }, cancelText))) : (footer);
        return React.createElement("div", { className: `${prefixCls}-footer ${prefixCls}-footer-${footerAlign}` }, footerContent);
    };
    const getOverlay = (prefixCls) => (React.createElement(React.Fragment, null,
        title && React.createElement("div", { className: `${prefixCls}-title` }, getRenderPropValue(title)),
        closeable === true && React.createElement(Icon, { className: `${prefixCls}-close-btn`, type: 'close', onClick: closeFunction }),
        React.createElement("div", { className: `${prefixCls}-inner-content` }, getRenderPropValue(content)),
        renderFooter()));
    const prefixCls = getPrefixCls('popover', customizePrefixCls);
    const className = classNames({
        [`${prefixCls}-dark`]: type === 'dark',
        [`${prefixCls}-notitle`]: !title,
        [`${prefixCls}-closeable`]: closeable,
        [`${prefixCls}-nofooter`]: footer === false,
        [`${prefixCls}-glassmorphism`]: !!animation?.glassmorphism
    }, overlayClassName);
    const rootPrefixCls = getPrefixCls();
    return (React.createElement(Tooltip, { ...otherProps, prefixCls: prefixCls, 
        // @ts-ignore
        ref: ref, visible: visible, onVisibleChange: onVisibleChange, overlay: getOverlay(prefixCls), overlayClassName: className, transitionName: getTransitionName(rootPrefixCls, 'zoom-big', otherProps.transitionName) }));
});
Popover.displayName = 'Popover';
Popover.defaultProps = {
    closeable: false,
    footer: true,
    okText: '确定',
    cancelText: '取消',
    footerAlign: 'left',
    placement: 'top',
    trigger: 'hover',
    mouseEnterDelay: 0.1,
    mouseLeaveDelay: 0.1,
    overlayStyle: {}
};
// const ConfiguredPopover = withConfigProvider(Popover);
const ConfiguredPopover = Popover;
export { ConfiguredPopover as Popover };
export default ConfiguredPopover;
